/* Design system: shared scroll-in animation trigger.
   One IntersectionObserver for the whole page instead of every section
   that wants an animation shipping its own copy. Elements opt in via
   the data-ds-animate attribute (see snippets/ds-animate.liquid); the
   actual animation (what it looks like) lives in design-system.css —
   this file only ever toggles one class. */
(function () {
  function revealImmediately() {
    document.querySelectorAll('[data-ds-animate]').forEach(function (el) {
      el.classList.add('ds-in-view');
    });
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!('IntersectionObserver' in window) || reducedMotion.matches) {
    revealImmediately();
    return;
  }

  var io = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ds-in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  function observeAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-ds-animate]:not(.ds-in-view)').forEach(function (el) {
      io.observe(el);
    });
  }

  observeAll();

  // Theme editor swaps section HTML via AJAX on setting changes —
  // newly injected elements need to be picked up without a reload.
  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
  });

  reducedMotion.addEventListener('change', function (mq) {
    if (mq.matches) revealImmediately();
  });
})();
